import { render, staticRenderFns } from "./TableSettings.vue?vue&type=template&id=f649997a&scoped=true&"
import script from "./TableSettings.vue?vue&type=script&lang=js&"
export * from "./TableSettings.vue?vue&type=script&lang=js&"
import style0 from "./TableSettings.vue?vue&type=style&index=0&id=f649997a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f649997a",
  null
  
)

export default component.exports
import {QCheckbox,QBtn,QTooltip,QToggle,QInput,QIcon,QItemLabel,QTabs,QTab,QBadge,QInnerLoading,QSpinnerGears} from 'quasar'
component.options.components = Object.assign({QCheckbox,QBtn,QTooltip,QToggle,QInput,QIcon,QItemLabel,QTabs,QTab,QBadge,QInnerLoading,QSpinnerGears}, component.options.components || {})
